import './side.less'
import { useState } from 'react'
import Selector from '../selector/index.jsx'
import Radio from '../radio/index.jsx'
import ImageBox from '../imageBox/index.jsx'
import EffectDisplay from '../effectDisplay/index.jsx'
import React from 'react'
console.log(React)

export default function TopImageSide(props) {
  let src = null

  if (props.ifon.ad_location === 'sns') {
    if (props.ifon.outer_style) {
      src = props.ifon.imgeIfon.sns.cardAdvertising.path
    } else {
      src = props.ifon.imgeIfon.sns.regularAdvertising.path
    }
  } else {
    src = props.ifon.imgeIfon.gzh.path
  }

  const [ifon, setIfon] = useState({
    space: props.ifon.ad_location,
    options: [{ text: '常规广告', id: 0, src: 'https://wxa.wxs.qq.com/images/yijie/placeholders/pyq-placeholder-regular-img-1.png' }, { text: '卡片广告', id: 1, src: 'http://wxa.wxs.qq.com/images/yijie/placeholders/pyq-placeholder-card.png' }],
    activeId: props.ifon.outer_style
  })

  return (<div className='Side'>
    <div className='side_no1'>
      <h3 className='no1_title'>顶部组件：图片</h3>
      <div className='no1_box'>支持腾讯广告全广告位</div>
    </div>
    <div className='side_no2'>
      <span className='no2_text'>投放朋友圈信息流，广告外层将自动拉取顶部图片。</span>
      <span className='no2_text'>投放公众号及腾讯广告其他媒体广告位，将不会拉取。</span>
    </div>
    <div className='side_no3'>
      <h3 className='no3_title'>广告位与样式</h3>
      <div className='no3_div1'>
        <span className='div1_title'>广告位</span>
        <div className='div_box'>
          <div className='box_item'>
            <Radio radio={ifon.space} label={'sns'} change={(label) => {
              setIfon({
                ...ifon,
                space: label
              })
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                ad_location: 'sns'
              })
            }}>朋友圈信息流</Radio>
          </div>
          <div className='box_item'>
            <Radio radio={ifon.space} label={'gzh'} change={(label) => {
              setIfon({
                ...ifon,
                space: label
              })
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                ad_location: 'gzh'
              })
            }}>公众号及及腾讯广告其他媒体广告位</Radio>
          </div>
        </div>
      </div>
      {ifon.space === 'sns' && (<div className='no3_div1'>
        <span className='div1_title'>外层样式</span>
        <div className='div_box'>
          <Selector options={ifon.options} activeId={ifon.activeId} change={(item) => {
            setIfon({
              ...ifon,
              activeId: item.id
            })
            props.mySetIfon && props.mySetIfon({
              ...props.ifon,
              outer_style: item.id
            })
          }}></Selector>
        </div>
      </div>)}

    </div>
    <div className='side_no3'>
      <h3 className='no3_title'>素材设置</h3>
      <div className='no3_div1'>
        <span className='div1_title'>图片素材</span>
        <div className='div_box'>
          <div className='box_img'>
            <ImageBox src={src} change={props.hoistPopup} mySwitch={props.hoistPopup}></ImageBox>
          </div>
          <div className='box_text'>
            <p className='text'>此图会同步作为朋友圈外层图<br /> 文字占图片篇幅不超过30%</p>
            <p className='text'>图片格式：大小不超过300KB，不支持GIF格式<br /> 图片尺寸：800 * 800像素</p>
          </div>
        </div>
      </div>
    </div>

    {ifon.space === 'sns' && <div className='side_no4' >
      <EffectDisplay src={ifon.options[ifon.activeId].src}>查看广告位外层效果</EffectDisplay>
    </div>}

  </div>)
}
